export default __webpack_public_path__ + "static/media/twitterBlack.5816540e.svg";